module.exports = __webpack_public_path__ + "img/login-bg-flight.9c7a0b14.svg";